
function requestAPI(data, token) {
  return fetch(`${process.env.REACT_APP_AGENT_URL}password`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify(data)
  }).then((res) => res.json())
}

export default function actionChangePassword(data) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: 'GET_CHANGE_PASSWORD_BEGIN' })

      const token = await getState().auth.authenticate.token
      const result = await requestAPI(data, token)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'GET_CHANGE_PASSWORD_SUCCESS',
        success: result
      })
    } catch(err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'GET_CHANGE_PASSWORD_FAILURE',        
    error: error    
  })
}
